import * as React from 'react';
import { Component } from 'react';

import GastrographRadarChart from '../../components/GastrographRadarChart';

type Props = {
  // loading: boolean,
  productReview: object;
};

export default class ProductReviewContainer extends Component {
  props: Props;

  render() {
    const { productReview } = this.props;

    return (
      <div>
        {productReview && (
          <GastrographRadarChart gastrographEntry={productReview} />
        )}
      </div>
    );
  }
}
